import { useState, useEffect } from 'react';

export default function useIsIframe() {
  const [isIframe, setIsIframe] = useState(false);

  useEffect(() => {
    setIsIframe(window.self !== window.top);
  }, []);

  return isIframe;
}
